import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        loadedLanguage: { type: String },
    },
});
